export const sentenceCase = (text) => text.replace(/(?:^|\.\s|\?\s)(\S)/g, (match, firstLetter) => firstLetter.toUpperCase());